/* Hushlab self-serve subscription portal.
 * Uses Shopify Customer Account API with OAuth PKCE (public client — no secret in browser).
 * The access token is scoped to the logged-in customer, so this can ONLY see/modify
 * that customer's own contracts. No admin credentials are involved anywhere.
 *
 * Config comes from window.HL_SUBS (set by subscription-portal.liquid).
 */
(function () {
  var CFG = window.HL_SUBS || {};
  // Endpoints from the store's Customer Account API discovery doc
  // (/.well-known/openid-configuration + /.well-known/customer-account-api).
  var AUTH_BASE = CFG.accountOrigin + '/authentication';
  var API_URL = CFG.accountOrigin + '/customer/api/2026-07/graphql';
  var SCOPE = 'openid email customer-account-api:full';
  var SS = window.sessionStorage;

  var el = {
    loading: document.getElementById('subs-loading'),
    login: document.getElementById('subs-login'),
    list: document.getElementById('subs-list'),
    empty: document.getElementById('subs-empty'),
    error: document.getElementById('subs-error'),
  };
  function show(node) {
    [el.loading, el.login, el.list, el.empty, el.error].forEach(function (n) { if (n) n.hidden = true; });
    if (node) node.hidden = false;
  }
  function fail(msg) {
    if (el.error) el.error.innerHTML = '<p>' + msg + ' Email <a href="mailto:' + CFG.supportEmail + '">' + CFG.supportEmail + '</a> and we\'ll sort it out.</p>';
    show(el.error);
  }

  // ---- PKCE helpers ----
  function rand(n) {
    var a = new Uint8Array(n); crypto.getRandomValues(a);
    return btoa(String.fromCharCode.apply(null, a)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function sha256b64url(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      var bytes = new Uint8Array(buf);
      var bin = ''; for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
      return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    });
  }

  function beginLogin() {
    var verifier = rand(48);
    var state = rand(16);
    var nonce = rand(16);
    SS.setItem('hl_pkce_verifier', verifier);
    SS.setItem('hl_pkce_state', state);
    sha256b64url(verifier).then(function (challenge) {
      var url = AUTH_BASE + '/oauth/authorize'
        + '?scope=' + encodeURIComponent(SCOPE)
        + '&client_id=' + encodeURIComponent(CFG.clientId)
        + '&response_type=code'
        + '&redirect_uri=' + encodeURIComponent(CFG.redirectUri)
        + '&state=' + state
        + '&nonce=' + nonce
        + '&code_challenge=' + challenge
        + '&code_challenge_method=S256';
      window.location.href = url;
    });
  }

  function exchangeCode(code) {
    var verifier = SS.getItem('hl_pkce_verifier');
    var body = new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: CFG.clientId,
      redirect_uri: CFG.redirectUri,
      code: code,
      code_verifier: verifier,
    });
    return fetch(AUTH_BASE + '/oauth/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body,
    }).then(function (r) { return r.json(); });
  }

  function gql(token, query, variables) {
    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': token },
      body: JSON.stringify({ query: query, variables: variables || {} }),
    }).then(function (r) { return r.json(); });
  }

  var LIST_QUERY =
    'query { customer { subscriptionContracts(first: 20) { edges { node {' +
    ' id status nextBillingDate' +
    ' upcomingBillingCycles(first: 3) { edges { node { billingAttemptExpectedDate skipped cycleIndex } } }' +
    ' deliveryPolicy { interval intervalCount { count } }' +
    ' lines(first: 5) { edges { node { name currentPrice { amount currencyCode } } } }' +
    ' } } } } }';

  function money(p) { return p ? (p.currencyCode === 'USD' ? '$' : '') + p.amount : ''; }
  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
    catch (e) { return iso; }
  }
  // Always spoken in days. Shopify stores the same real-world gap as MONTH/1 on
  // one plan and DAY/30 on another, and a customer comparing two cards should
  // not have to translate between them.
  function intervalLabel(dp) {
    if (!dp) return '';
    var perUnit = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 }[dp.interval];
    var n = (dp.intervalCount && dp.intervalCount.count) || 1;
    if (!perUnit) return '';
    var days = perUnit * n;
    return days === 1 ? 'every day' : 'every ' + days + ' days';
  }

  // The cycle the customer will actually be charged for: the first upcoming
  // cycle that is not skipped. nextBillingDate alone lies for a day or two after
  // a skip, until the billing robot moves it.
  function cycles(c) {
    return ((c.upcomingBillingCycles && c.upcomingBillingCycles.edges) || []).map(function (e) { return e.node; });
  }
  function nextCycle(c) {
    var list = cycles(c);
    for (var i = 0; i < list.length; i++) if (!list[i].skipped) return list[i];
    return null;
  }
  function numericId(gid) { return String(gid || '').replace(/\D/g, ''); }

  // One-click links from the refill reminder email land here with
  // ?action=skip|pause|cancel&contract=<id>. Read once, then cleared so a
  // reload never repeats the action.
  var PENDING_TTL_MS = 15 * 60 * 1000;
  var PENDING = (function () {
    var q = new URLSearchParams(window.location.search);
    var a = q.get('action'), id = q.get('contract'), cycle = q.get('cycle');
    if (!a || !id) {
      var saved = SS.getItem('hl_pending_action');
      var p0 = saved ? JSON.parse(saved) : null;
      // A link clicked, then abandoned at login, must not fire on some later
      // visit in the same tab.
      if (p0 && Date.now() - (p0.at || 0) > PENDING_TTL_MS) { SS.removeItem('hl_pending_action'); return null; }
      return p0;
    }
    var p = { action: a, contract: id, cycle: cycle || null, at: Date.now() };
    SS.setItem('hl_pending_action', JSON.stringify(p)); // survives the login redirect
    return p;
  })();
  function clearPending() { PENDING = null; SS.removeItem('hl_pending_action'); }

  function notice(card, text, kind) {
    var n = card.querySelector('.hl-subs__notice-inline');
    if (!n) { n = document.createElement('div'); n.className = 'hl-subs__notice-inline'; card.insertBefore(n, card.querySelector('.hl-sub-card__actions')); }
    n.textContent = text;
    n.style.cssText = 'margin:12px 0 4px;padding:10px 12px;border-radius:10px;font-size:0.92rem;' +
      (kind === 'ok' ? 'background:#eef6ee;color:#2e7d32;' : 'background:#faf7f2;color:#333;');
  }

  // Why they left is the single most useful thing a cancelling customer can
  // tell us, and they will only say it in the two seconds before they close the
  // tab. So it is one tap, on the card, right after the cancel goes through.
  // The tap opens a pre-filled email; the support bot reads the subject code and
  // writes the reason into the retention ledger.
  var CANCEL_REASONS = [
    { bucket: 'too_expensive', label: 'Too expensive' },
    { bucket: 'enough_stock', label: 'Have enough for now' },
    { bucket: 'not_working', label: "Didn't see results" },
    { bucket: 'dog_refused', label: "My dog wouldn't take it" },
    { bucket: 'other', label: 'Something else' },
  ];
  function cancelReasonLink(bucket, label, id, note) {
    var subject = 'CANCELREASON ' + bucket + ' contract ' + numericId(id);
    var body = 'I cancelled my subscription. Reason: ' + label + '.' + (note ? '\n\n' + note : '');
    return 'mailto:' + CFG.supportEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }
  function askCancelReason(card, id) {
    var n = card.querySelector('.hl-subs__notice-inline');
    if (!n) { n = document.createElement('div'); n.className = 'hl-subs__notice-inline'; card.insertBefore(n, card.querySelector('.hl-sub-card__actions')); }
    n.style.cssText = 'margin:12px 0 4px;padding:10px 12px;border-radius:10px;font-size:0.92rem;background:#eef6ee;color:#2e7d32;';
    n.innerHTML = '';
    var done = document.createElement('p'); done.style.cssText = 'margin:0 0 6px;font-weight:600;'; done.textContent = 'Cancelled.';
    var ask = document.createElement('p'); ask.style.cssText = 'margin:0 0 10px;color:#333;'; ask.textContent = 'Mind telling us why? One tap:';
    n.appendChild(done); n.appendChild(ask);
    var wrap = document.createElement('div'); wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;';
    function thanks() {
      n.innerHTML = '';
      var t = document.createElement('p'); t.style.margin = '0';
      t.textContent = 'Cancelled. Thanks, that helps. Send the email your mail app just opened and we have it.';
      n.appendChild(t);
    }
    CANCEL_REASONS.forEach(function (r) {
      if (r.bucket === 'other') {
        // "Something else" has to say what (Nate, 2026-09-22): a text box
        // replaces the one-tap link, and Send opens the same pre-filled email
        // with their words in the body.
        var b = btn(r.label, 'hl-btn hl-btn--ghost', function () {
          wrap.hidden = true;
          var box = document.createElement('div'); box.style.cssText = 'display:flex;flex-direction:column;gap:8px;';
          var ta = document.createElement('textarea'); ta.rows = 3; ta.placeholder = 'Tell us why in a sentence or two'; ta.style.cssText = 'width:100%;padding:8px;border:1px solid #cfd8cf;border-radius:8px;font:inherit;';
          var send = btn('Send', 'hl-btn hl-btn--primary', function () {
            var note = ta.value.trim();
            if (!note) { ta.focus(); ta.style.borderColor = '#c62828'; return; }
            window.location.href = cancelReasonLink(r.bucket, r.label, id, note);
            setTimeout(thanks, 300);
          });
          box.appendChild(ta); box.appendChild(send);
          n.appendChild(box);
          ta.focus();
        });
        wrap.appendChild(b);
        return;
      }
      var a = document.createElement('a');
      a.className = 'hl-btn hl-btn--ghost';
      a.textContent = r.label;
      a.href = cancelReasonLink(r.bucket, r.label, id);
      a.addEventListener('click', function () { setTimeout(thanks, 300); });
      wrap.appendChild(a);
    });
    n.appendChild(wrap);
  }

  // Shopify's new customer accounts keep saved payment methods under Profile,
  // not under a page of their own, so the label has to say where to look or
  // people land on Profile and think they are in the wrong place.
  // One row for the whole account, appended under the list. Repeating it on
  // every card made the page read like each subscription had its own payment
  // method and its own order history, which is not true.
  function accountLinks(parent) {
    var row = document.createElement('div');
    row.className = 'hl-sub-card__links';
    row.style.cssText = 'margin-top:14px;font-size:0.88rem;';
    [['Update payment method (under Profile)', '/profile'], ['Order history', '/orders']].forEach(function (pair, i) {
      var a = document.createElement('a');
      a.href = CFG.accountOrigin + pair[1];
      a.textContent = pair[0];
      a.style.cssText = 'color:#555;text-decoration:underline;' + (i ? 'margin-left:14px;' : '');
      row.appendChild(a);
    });
    parent.appendChild(row);
  }

  // Frequency / bottle changes need admin-only Shopify mutations, so like
  // KEEP40 they go by email: the subject carries a code the support bot acts
  // on and confirms by reply. The next refill date never moves.
  var FREQ_OPTIONS = [
    { days: 30, label: 'Every 30 days (about once a month)' },
    { days: 45, label: 'Every 45 days (about every 6 weeks)' },
    { days: 60, label: 'Every 60 days (about every 2 months)' },
    { days: 90, label: 'Every 90 days (about every 3 months)' },
  ];
  var BOTTLE_OPTIONS = [
    { bottles: 1, label: '1 bottle per refill, $29.99' },
    { bottles: 3, label: '3 bottles per refill, $59.99' },
    { bottles: 5, label: '5 bottles per refill, $89.99' },
  ];
  function currentDays(c) {
    var dp = c.deliveryPolicy || {};
    var unit = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 }[dp.interval] || 30;
    return unit * ((dp.intervalCount && dp.intervalCount.count) || 1);
  }
  function currentBottles(line) {
    var m = String(line.name || '').match(/(\d)\s*bottle/i);
    return m ? Number(m[1]) : null;
  }
  // Shopify plan names carry a long dash ("Refill — 3 Bottles"); customers
  // see a comma instead.
  function cleanName(name) { return String(name || '').replace(/\s*\u2014\s*/g, ', '); }
  function planChangeLink(c, days, bottles) {
    var codes = [];
    if (days) codes.push('FREQ' + days);
    if (bottles) codes.push('BOTTLES' + bottles);
    var subject = codes.join(' ') + ' contract ' + numericId(c.id);
    var what = [];
    if (days) what.push('ship every ' + days + ' days');
    if (bottles) what.push('send ' + bottles + ' bottle' + (bottles === 1 ? '' : 's') + ' per refill');
    var body = 'Please change my subscription to ' + what.join(' and ') + '. Keep my next refill date as it is.';
    return 'mailto:' + CFG.supportEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }
  function select(options, current, key) {
    var s = document.createElement('select');
    s.style.cssText = 'display:block;width:100%;max-width:360px;padding:12px;border:1px solid #bbb;border-radius:10px;margin:0 0 10px;font-size:1rem;background:#fff;color:#111;';
    options.forEach(function (o) {
      var op = document.createElement('option'); op.value = String(o[key]); op.textContent = o.label + (o[key] === current ? ' (current)' : '');
      if (o[key] === current) op.selected = true;
      s.appendChild(op);
    });
    return s;
  }
  function planChangePanel(c, line, panel, nextDate) {
    // A second click on "Change schedule" must not append a second set of
    // selects and buttons underneath the first.
    if (!panel.hidden) return;
    var others = panel.parentNode.querySelector('.hl-subs__winback');
    if (others) { others.hidden = true; others.innerHTML = ''; }
    panel.hidden = false;
    var days = currentDays(c);
    var bottles = currentBottles(line);
    panel.innerHTML =
      '<p style="margin-bottom:10px;"><strong>Change your schedule.</strong> Your next refill still comes ' + fmtDate(nextDate) + '. The new schedule starts after that one.</p>';
    var freqLabel = document.createElement('div'); freqLabel.textContent = 'How often'; freqLabel.style.cssText = 'font-size:0.85rem;color:#555;margin-bottom:4px;';
    panel.appendChild(freqLabel);
    var freq = select(FREQ_OPTIONS, days, 'days');
    panel.appendChild(freq);
    var qty = null;
    if (bottles) {
      var qLabel = document.createElement('div'); qLabel.textContent = 'How many bottles each time'; qLabel.style.cssText = 'font-size:0.85rem;color:#555;margin-bottom:4px;';
      panel.appendChild(qLabel);
      qty = select(BOTTLE_OPTIONS, bottles, 'bottles');
      panel.appendChild(qty);
    } else {
      var note = document.createElement('p'); note.textContent = 'This plan comes one pack at a time, so there is no bottle option.'; note.style.cssText = 'font-size:0.85rem;color:#555;margin:0 0 10px;';
      panel.appendChild(note);
    }
    var hint = document.createElement('div'); hint.style.cssText = 'font-size:0.9rem;color:#555;margin:4px 0 10px;';
    panel.appendChild(hint);
    var go = document.createElement('a');
    go.className = 'hl-btn hl-btn--primary';
    var close = btn('Never mind', 'hl-btn hl-btn--ghost', function () { panel.hidden = true; panel.innerHTML = ''; });
    close.style.marginLeft = '8px';
    function refresh() {
      var d = Number(freq.value), b = qty ? Number(qty.value) : null;
      var newDays = d !== days ? d : null, newBottles = b && b !== bottles ? b : null;
      var changed = !!(newDays || newBottles);
      if (!changed) {
        hint.textContent = 'Pick a different option above to make a change.';
        go.textContent = 'Email us this change';
        go.removeAttribute('href'); go.style.opacity = '0.5'; go.style.pointerEvents = 'none';
        return;
      }
      var parts = [];
      if (newDays) parts.push('every ' + newDays + ' days');
      if (newBottles) parts.push(newBottles + ' bottle' + (newBottles === 1 ? '' : 's') + ' at $' + BOTTLE_OPTIONS.filter(function (o) { return o.bottles === newBottles; })[0].label.split('$')[1] + ' per refill');
      hint.textContent = 'You are asking for: ' + parts.join(', ') + '.';
      go.textContent = 'Email us this change';
      go.href = planChangeLink(c, newDays, newBottles); go.style.opacity = '1'; go.style.pointerEvents = 'auto';
    }
    go.addEventListener('click', function () {
      if (!go.getAttribute('href')) return;
      setTimeout(function () {
        panel.innerHTML = '<p><strong>Your mail app just opened.</strong> Send that email and we will confirm by email. This page updates once the change is made.</p>';
        var ok = btn('Close', 'hl-btn hl-btn--ghost', function () { panel.hidden = true; panel.innerHTML = ''; });
        panel.appendChild(ok);
      }, 300);
    });
    freq.addEventListener('change', refresh); if (qty) qty.addEventListener('change', refresh); refresh();
    panel.appendChild(go); panel.appendChild(close);
  }

  function keep40Link(c) {
    var subject = 'KEEP40 contract ' + numericId(c.id);
    var body = 'Yes, keep my subscription and apply 40% off my next refill.';
    return 'mailto:' + CFG.supportEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  // Skip before cancel (Nate, 2026-09-22). The Cancel button's first screen
  // offers a skip of the next refill, with a plain reminder of how the product
  // works, written to fit whatever the dog is taking it for. The 40%-off /
  // pause / cancel screen comes only after "I still want to cancel". A refill
  // already skipped, or a paused contract, goes straight to that screen.
  function showSkipFirst(token, c, card, winback, next) {
    var paused = c.status === 'PAUSED';
    var firstSkipped = cycles(c)[0] && cycles(c)[0].skipped;
    if (paused || firstSkipped || !next) { showWinback(token, c, card, winback); return; }
    var plan = card.querySelector('.hl-subs__planchange');
    if (plan) { plan.hidden = true; plan.innerHTML = ''; }
    var moved = '';
    try {
      var d = new Date(next.billingAttemptExpectedDate);
      var p = c.deliveryPolicy || {};
      var n = p.intervalCount || 1;
      if (p.interval === 'WEEK') d.setUTCDate(d.getUTCDate() + 7 * n);
      else if (p.interval === 'MONTH') d.setUTCMonth(d.getUTCMonth() + n);
      else if (p.interval === 'YEAR') d.setUTCFullYear(d.getUTCFullYear() + n);
      else d.setUTCDate(d.getUTCDate() + (p.interval === 'DAY' ? n : 30 * n));
      moved = ' Your next order moves to <strong>' + fmtDate(d.toISOString()) + '</strong>.';
    } catch (e) { moved = ''; }
    winback.hidden = false;
    winback.innerHTML =
      '<p style="margin-bottom:10px;">Before you cancel: do you want to skip the next refill instead? Nothing ships and nothing is charged for it.' + moved + '</p>' +
      '<p style="margin-bottom:12px;">Collagen needs a few months of daily use to work. Most owners see the first change around week 4 and the full effect around month 3. Stopping after one bottle is the main reason people don\'t see results.</p>';
    var skip = btn('Skip next refill', 'hl-btn hl-btn--primary', function () { act(token, 'skip', c.id, card, next, 'Skipped. Nothing ships and nothing is charged for this refill.'); });
    skip.style.marginRight = '8px';
    var still = btn('I still want to cancel', 'hl-btn hl-btn--ghost', function () { showWinback(token, c, card, winback); });
    winback.appendChild(skip); winback.appendChild(still);
  }

  function showWinback(token, c, card, winback) {
    var plan = card.querySelector('.hl-subs__planchange');
    if (plan) { plan.hidden = true; plan.innerHTML = ''; }
    winback.hidden = false;
    winback.innerHTML =
      '<p style="margin-bottom:12px;">Before you go: keep it and take <strong>40% off your next refill</strong>, one email, no strings. ' +
      'Or pause instead. Your spot and pricing stay, and you can restart any time.</p>';
    var keep = document.createElement('a');
    keep.className = 'hl-btn hl-btn--primary'; keep.href = keep40Link(c); keep.textContent = 'Keep it, 40% off next refill';
    keep.style.marginRight = '8px';
    var pause = btn('Pause instead', 'hl-btn hl-btn--ghost', function () { act(token, 'pause', c.id, card); });
    var confirm = btn('No, cancel my subscription', 'hl-btn hl-btn--danger', function () { act(token, 'cancel', c.id, card); });
    winback.appendChild(keep); winback.appendChild(pause); winback.appendChild(document.createTextNode(' ')); winback.appendChild(confirm);
  }

  function render(token, contracts) {
    if (!contracts.length) { clearPending(); show(el.empty); return; }
    el.list.innerHTML = '';
    contracts.forEach(function (c) {
      var line = (c.lines.edges[0] || {}).node || {};
      var paused = c.status === 'PAUSED';
      var next = nextCycle(c);
      var nextDate = next ? next.billingAttemptExpectedDate : c.nextBillingDate;
      var firstSkipped = cycles(c)[0] && cycles(c)[0].skipped;
      var card = document.createElement('div');
      card.className = 'hl-sub-card';
      card.setAttribute('data-contract', numericId(c.id));
      card.innerHTML =
        '<div class="hl-sub-card__title">' + (cleanName(line.name) || 'Subscription') + '</div>' +
        '<div class="hl-sub-card__meta">' + money(line.currentPrice) + ' · ' + intervalLabel(c.deliveryPolicy) + '</div>' +
        '<div class="hl-sub-card__meta">Next order: ' + fmtDate(nextDate) + (firstSkipped ? ' (' + fmtDate(c.nextBillingDate) + ' skipped)' : '') + '</div>' +
        '<span class="hl-sub-card__status ' + (paused ? 'hl-sub-card__status--paused' : '') + '">' + (paused ? 'Paused' : 'Active') + '</span>' +
        '<div class="hl-sub-card__actions"></div>' +
        '<div class="hl-subs__planchange" hidden></div>' +
        '<div class="hl-subs__winback" hidden></div>';
      var actions = card.querySelector('.hl-sub-card__actions');
      var winback = card.querySelector('.hl-subs__winback');
      var planPanel = card.querySelector('.hl-subs__planchange');

      if (paused) {
        actions.appendChild(btn('Resume', 'hl-btn hl-btn--primary', function () { act(token, 'resume', c.id, card); }));
      } else {
        if (!firstSkipped && next) {
          actions.appendChild(btn('Skip next refill', 'hl-btn hl-btn--primary', function () { act(token, 'skip', c.id, card, next); }));
        }
        actions.appendChild(btn('Pause', 'hl-btn hl-btn--ghost', function () { act(token, 'pause', c.id, card); }));
      }
      // Paused customers get this too: the usual reason a refill is paused is
      // that it was coming too often, and 60 days is the fix they want before
      // they resume.
      actions.appendChild(btn('Change schedule', 'hl-btn hl-btn--ghost', function () { planChangePanel(c, line, planPanel, nextDate); }));
      var cancelBtn = btn('Cancel', 'hl-btn hl-btn--danger', function () { showSkipFirst(token, c, card, winback, next); });
      actions.appendChild(cancelBtn);
      el.list.appendChild(card);

      // Deep link from the reminder email: run it once, on the matching contract.
      if (PENDING && PENDING.contract === numericId(c.id)) {
        var a = PENDING.action; var PENDING_CYCLE = PENDING.cycle; clearPending();
        if (a === 'skip' && !paused) {
          // Only skip the cycle the email was about. If the robot already moved
          // the date (the first click worked), a second click must not skip the
          // following cycle as well.
          var wanted = PENDING_CYCLE;
          var nextDay = next ? String(next.billingAttemptExpectedDate).slice(0, 10) : '';
          if (firstSkipped) notice(card, 'This refill is already skipped.', 'ok');
          else if (wanted && nextDay && wanted !== nextDay) notice(card, 'That refill is already skipped. Your next order is ' + fmtDate(nextDate) + '.', 'ok');
          else if (next) act(token, 'skip', c.id, card, next, 'Skipped. Nothing ships and nothing is charged for this refill.');
        } else if (a === 'pause' && !paused) {
          act(token, 'pause', c.id, card, null, 'Paused. No refills or charges until you resume.');
        } else if (a === 'cancel') {
          showSkipFirst(token, c, card, winback, next);
          winback.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else if (PENDING && !contracts.some(function (x) { return numericId(x.id) === PENDING.contract; })) {
        clearPending();
      }
    });
    accountLinks(el.list);
    show(el.list);
  }

  function btn(label, cls, onClick) {
    var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.textContent = label;
    b.addEventListener('click', onClick); return b;
  }

  var MUTATIONS = {
    pause: 'mutation($id: ID!){ subscriptionContractPause(subscriptionContractId:$id){ contract{ id status } userErrors{ message } } }',
    resume: 'mutation($id: ID!){ subscriptionContractActivate(subscriptionContractId:$id){ contract{ id status } userErrors{ message } } }',
    cancel: 'mutation($id: ID!){ subscriptionContractCancel(subscriptionContractId:$id){ contract{ id status } userErrors{ message } } }',
    // Skip marks ONE billing cycle skipped. The billing robot sees the flag and
    // moves the next charge out a cycle; nothing is billed for the skipped one.
    skip: 'mutation($id: ID!, $index: Int!){ subscriptionBillingCycleSkip(billingCycleInput:{ contractId:$id, selector:{ index:$index } }){ billingCycle{ skipped cycleIndex } userErrors{ message } } }',
  };
  var PENDING_MSG = null;

  function act(token, kind, id, card, cycle, doneMsg) {
    card.style.opacity = '0.5';
    var vars = { id: id };
    if (kind === 'skip') vars.index = cycle.cycleIndex;
    gql(token, MUTATIONS[kind], vars).then(function (res) {
      var d = res && res.data;
      var data = d && (d.subscriptionContractPause || d.subscriptionContractActivate || d.subscriptionContractCancel || d.subscriptionBillingCycleSkip);
      // A top-level GraphQL error (expired login, throttle) means nothing
      // happened. Never confirm an action Shopify did not perform.
      if (!res || res.errors || !data) { card.style.opacity = '1'; fail('That didn\'t go through. Please log in again and retry.'); return; }
      var errs = data.userErrors;
      if (errs && errs.length) { card.style.opacity = '1'; fail(errs.map(function (e) { return e.message; }).join(' ')); return; }
      PENDING_MSG = { contract: numericId(id), contractId: id, ask: kind === 'cancel', text: doneMsg || (kind === 'skip' ? 'Skipped. Nothing ships and nothing is charged for this refill.' : kind === 'pause' ? 'Paused.' : kind === 'resume' ? 'Resumed.' : 'Cancelled.') };
      loadContracts(token); // refresh
    }).catch(function () { card.style.opacity = '1'; fail('That didn\'t go through.'); });
  }

  function loadContracts(token) {
    show(el.loading);
    gql(token, LIST_QUERY).then(function (res) {
      if (!res.data || !res.data.customer) { fail('We couldn\'t load your subscriptions.'); return; }
      var edges = res.data.customer.subscriptionContracts.edges || [];
      var active = edges.map(function (e) { return e.node; }).filter(function (n) { return n.status === 'ACTIVE' || n.status === 'PAUSED'; });
      render(token, active);
      if (PENDING_MSG) {
        // render() leaves the stale cards in #subs-list when the fresh list is
        // empty, it just hides the list. Attaching the notice there would put
        // the reason buttons inside a hidden element, so the customer never
        // sees them. Only use the card branch when the list is actually shown.
        var card = el.list.hidden ? null : el.list.querySelector('[data-contract="' + PENDING_MSG.contract + '"]');
        if (card && PENDING_MSG.ask) askCancelReason(card, PENDING_MSG.contractId);
        else if (card) notice(card, PENDING_MSG.text, 'ok');
        else if (el.empty && !active.length) {
          // A cancel usually leaves nothing to render, so the ask has to live on
          // the empty state or the question is never put at all.
          // askCancelReason writes its own "Cancelled." heading, so adding this
          // paragraph as well would say it twice.
          if (!PENDING_MSG.ask) el.empty.insertAdjacentHTML('afterbegin', '<p style="color:#2e7d32;margin-bottom:10px;">' + PENDING_MSG.text + '</p>');
          if (PENDING_MSG.ask) {
            var holder = document.createElement('div');
            holder.setAttribute('data-contract', PENDING_MSG.contract);
            holder.innerHTML = '<div class="hl-sub-card__actions"></div>';
            el.empty.insertBefore(holder, el.empty.firstChild);
            askCancelReason(holder, PENDING_MSG.contractId);
          }
        }
        PENDING_MSG = null;
      }
    }).catch(function () { fail('We couldn\'t load your subscriptions.'); });
  }

  // ---- entry ----
  function init() {
    if (!CFG.clientId) return; // fallback notice already shown server-side
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var returnedState = params.get('state');
    var token = SS.getItem('hl_customer_token');

    if (code) {
      if (returnedState !== SS.getItem('hl_pkce_state')) { fail('Login could not be verified.'); return; }
      show(el.loading);
      exchangeCode(code).then(function (tok) {
        if (!tok.access_token) { fail('Login failed.'); return; }
        // Customer Account API expects the raw access token as the Authorization
        // header value — NO "Bearer " scheme prefix.
        SS.setItem('hl_customer_token', tok.access_token);
        window.history.replaceState({}, document.title, CFG.redirectUri); // strip ?code (pending action lives in sessionStorage)
        loadContracts(tok.access_token);
      }).catch(function () { fail('Login failed.'); });
      return;
    }

    if (token) {
      // Drop ?action=... from the address bar so a reload cannot re-arm it.
      if (window.location.search) window.history.replaceState({}, document.title, CFG.redirectUri);
      loadContracts(token); return;
    }

    show(el.login);
    var lb = document.getElementById('subs-login-btn');
    if (lb) lb.addEventListener('click', beginLogin);
    // A reminder-email click should not need a second click to start login.
    if (PENDING) beginLogin();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
